import { render } from "./EmailField.vue?vue&type=template&id=52aa1677"
import script from "./EmailField.vue?vue&type=script&lang=ts"
export * from "./EmailField.vue?vue&type=script&lang=ts"
script.render = render

export default script